import { useState } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';

interface IProps {
  shouldOpen: boolean;
}

const OrderRegisterSuccessSheet = ({shouldOpen}: IProps) => {
  const [isOpen, setIsOpen] = useState(shouldOpen);
  return (
    <BottomSheet
      onDismiss={() => {
        setIsOpen(false);
      }}
      open={isOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 p-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-3xl text-gray-500 icon-nameClose-remove top-6 left-6"
          onClick={() => setIsOpen(false)}
        />

        <div className="flex flex-col items-center justify-center gap-1">
          <i className="icon-nameCheck-circle text-5xl text-farm-shop-500 w-[10%]" />
        </div>

        <p className="flex justify-center w-full p-0 m-0 mb-2 text-xl font-medium text-zinc-800">
          ثبت سفارش موفق
        </p>

        <div className="flex flex-col justify-between w-full gap-4">
          <div className="w-full p-0 m-0 text-lg text-right text-gray-700 font-Regular">
            پرداخت شما با موفقیت انجام شد و سفارش شما ثبت شد. شما می‌توانید
            وضعیت و جزئیات سفارشتان را از قسمت سفارش‌های من پیگیری کنید.
          </div>

          <div className="flex items-center gap-2">
            <Button
              className="w-full"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              متوجه شدم
            </Button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default OrderRegisterSuccessSheet;
